export default {"src":"/_next/static/media/badge-filled.8c17dff1.svg","height":24,"width":24};